import IdentityTile from '@Guidelines/Component/IdentityTile';
import { css } from '@emotion/react';
import type * as React from 'react';

const headerRowStyle = css`
	display: flex;
	align-items: flex-start;
	gap: 0.875rem;
`;

const identityTextStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	flex: 1;
	min-width: 0;
`;

type Props = {
	readonly initials: string;
	readonly seed: number;
	/** The text column beside the tile: title row, then the metadata lines. */
	readonly children: React.ReactNode;
};

/** The identity row of a list card: tile on the left, text column on the right. */
const SubjectCardIdentity: React.FC<Props> = ({ initials, seed, children }) => {
	return (
		<div css={headerRowStyle}>
			<IdentityTile label={initials} seed={seed} size="large" />
			<div css={identityTextStyle}>{children}</div>
		</div>
	);
};

export default SubjectCardIdentity;
